import { defineStore } from "pinia";
import { useToast } from "vue-toastification";

import { copyableToastOptions } from "@/utils/toastOptionsUtils";
import { toastIdFromText, toastTextWithCount } from "@/utils/toastIdUtils";

export const useNotificationStore = defineStore("notification", {
  state: () => ({
    toastDuplicateCounts: {},
  }),
  actions: {
    showSuccess(message, options = {}) {
      const toast = useToast();
      toast.success(message, {
        timeout: 4000,
        ...options,
      });
    },

    showError(message, options = {}) {
      const toast = useToast();
      // Один id для одинаковой ошибки заставляет toast обновляться вместо стопки дублей.
      // Счетчик оставляем в тексте, чтобы пользователь видел, что ошибка повторилась.
      const toastId = options.id || toastIdFromText("error", message);
      const duplicateCount = this.incrementToastDuplicateCount(toastId);
      const { onClose } = options;

      toast.error(
        toastTextWithCount(message, duplicateCount),
        copyableToastOptions(message, {
          timeout: 5000,
          ...options,
          id: toastId,
          closeOnClick: false,
          onClose: (...args) => {
            this.resetToastDuplicateCount(toastId);
            if (onClose) {
              onClose(...args);
            }
          },
        })
      );
    },

    showInfo(message, options = {}) {
      const toast = useToast();
      toast.info(message, {
        timeout: 5000,
        ...options,
      });
    },

    showWarning(message, options = {}) {
      const toast = useToast();
      toast.warning(message, {
        timeout: 6000,
        ...options,
      });
    },

    // Для кастомных сценариев:
    // notificationStore.showCustomNotification('success', 'Успешно!', {
    //   timeout: false,
    //   closeOnClick: false,
    //   icon: 'check-circle'
    // });
    showCustomNotification(type, message, options = {}) {
      const toast = useToast();
      toast[type](message, options);
    },

    // Закрыть все тосты
    clearAll() {
      const toast = useToast();
      toast.clear();
      this.toastDuplicateCounts = {};
    },

    incrementToastDuplicateCount(toastId) {
      const count = (this.toastDuplicateCounts[toastId] || 0) + 1;
      this.toastDuplicateCounts[toastId] = count;

      return count;
    },

    resetToastDuplicateCount(toastId) {
      delete this.toastDuplicateCounts[toastId];
    },
  },
});
